module.exports = __webpack_public_path__ + "img/zero-board.6f98ec20.png";